import { useQuery } from '@tanstack/react-query';
import { fetchShipmentProductHazmat } from '../../data-provider/select-options';

export const useGetShipmentProductHazmat = () => {
  return useQuery({
    queryKey: ['shipment-product-hazmat'],
    queryFn: () => fetchShipmentProductHazmat(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
